import { Box, CircularProgress, useTheme } from "@mui/material";
import PageBanner from "../components/application/PageBanner";
import { ClientRequestText } from "../data/texts";
import { ImageService } from "../services/image.service";
import { Images } from "../models/assets-files";
import RequestList from "../components/client-requests/RequestList";
import { useEffect, useState } from "react";
import { UserService } from "../services/user.service";
import { ClientRequest } from "../models/user.models";
import useScreen from "../components/common/UseScreen";

const ClientRequestsPage = () => {
  const [requests, setRequests] = useState<ClientRequest[]>();
  const [isLoading, setIsLoading] = useState(true);
  const theme = useTheme();
  const { isDesktop } = useScreen();

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    const response = await UserService.getUserContactUsRequests();
    setRequests(response);
  };
  useEffect(() => {
    if (requests) {
      setIsLoading(false);
    }
  }, [requests]);
  return (
    <Box
      sx={{
        padding: isDesktop ? "24px" : "0",
        ...(isLoading ? theme.customStyles.disabled : ""),
      }}
    >
      {isLoading && (
        <CircularProgress
          sx={{ position: "absolute", top: "70%", left: "50%" }}
        />
      )}
      <PageBanner
        imageSrc={ImageService.getLocalImgPath(
          Images.Folders.BANNERS,
          Images.Banners.LAPTOP_BIG,
          "png"
        )}
        containerSx={{ marginBottom: "30px" }}
        title={ClientRequestText.CLIENT_REQUESTS}
        subtitle={ClientRequestText.CLIENT_REQUESTS_DESCRIPTION}
      />
      <RequestList
        requests={requests || []}
        sx={{ width: isDesktop ? "80%" : "95%", marginInline: "auto" }}
      />
    </Box>
  );
};

export default ClientRequestsPage;
